module.exports = __webpack_public_path__ + "img/智能化设备管理平台.b5f44380.jpg";